"use client";

import { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const {
    ref: revealRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const meshRef = useRef<HTMLDivElement | null>(null);
  const [parallax, setParallax] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    if (typeof window === "undefined") return;
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const handleMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 16;
      const y = (e.clientY / window.innerHeight - 0.5) * 16;
      setParallax({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, []);
  return <section data-section-id="11513" id="get-in-touch" className="relative overflow-hidden bg-background text-foreground pt-32 md:pt-44 pb-28 md:pb-36">
      {}
      <div ref={meshRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/contact_network_grid.webp)] opacity-[0.18] mix-blend-screen transition-transform duration-[600ms] ease-out pointer-events-none" style={{
      transform: `translate3d(${parallax.x}px, ${parallax.y}px, 0)`
    }} aria-hidden="true" />

      {}
      <div className="absolute top-0 right-0 w-[60%] h-[60%] pointer-events-none" style={{
      background: "radial-gradient(circle at top right, hsl(240 100% 25% / 0.08), transparent 60%)"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-x-6 md:inset-x-8 inset-y-6 md:inset-y-8 border border-border/30" aria-hidden="true" />

      {}
      <div className="relative mx-auto max-w-[880px] px-6 md:px-12">
        <div ref={revealRef} className={`flex flex-col items-center text-center transition-all duration-[600ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          {}
          <span className="font-default text-foreground/70 uppercase font-medium" style={{
          fontSize: "clamp(0.75rem, 0.8vw, 0.8125rem)",
          letterSpacing: "0.14em",
          lineHeight: 1.2,
          transitionDelay: "0ms"
        }}>
            Connect With Us
          </span>

          {}
          <h1 className="font-default text-foreground mt-10 md:mt-12 font-normal" style={{
          fontSize: "clamp(2.75rem, 5.4vw, 4.75rem)",
          letterSpacing: "-0.02em",
          lineHeight: 1.04,
          transitionDelay: "80ms"
        }}>
            Ready to start your{" "}
            <em className="italic font-normal" style={{
            color: "var(--primary)"
          }}>
              next project
            </em>
          </h1>

          {}
          <p className="font-default text-foreground/80 mt-16 max-w-[64ch] font-normal" style={{
          fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
          letterSpacing: "-0.005em",
          lineHeight: 1.55,
          transitionDelay: "160ms"
        }}>
            Our team is ready to assist you with your inquiries. Whether you are looking for a partnership, technical support, or general information, we are here to provide the guidance you need to succeed.
          </p>

          {}
          <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 w-full sm:w-auto" style={{
          transitionDelay: "240ms"
        }}>
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 hover:-translate-y-px transition-all duration-200 ease-out h-auto px-6 py-3.5 rounded-lg font-medium" style={{
            letterSpacing: "0.02em",
            fontSize: "0.9375rem"
          }}>
              <Link to="/ContactPage">Send a Message</Link>
            </Button>
            <Button asChild variant="outline" className="border border-foreground bg-transparent text-foreground hover:text-primary hover:border-primary hover:-translate-y-px transition-all duration-200 ease-out h-auto px-6 py-3.5 rounded-lg font-medium" style={{
            letterSpacing: "0.02em",
            fontSize: "0.9375rem"
          }}>
              <Link to="/ServicesPage">View Our Services</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}